import { FILTER_TYPES } from './constants';

export const initialFilterState = {
  [FILTER_TYPES.ORGANIZATION]: [],
  [FILTER_TYPES.ROLE]: [],
  [FILTER_TYPES.LOCATION]: [],
  [FILTER_TYPES.STATUS]: [],
  [FILTER_TYPES.DOMAIN]: [],
  [FILTER_TYPES.SORT]: null
};

export const initialUIState = {
  openFilter: null,
  searchQuery: '',
  activeMetric: 'total'
};

export const initialCounts = {
  locationCounts: {},
  statusCounts: {},
  orgCounts: {},
  roleCounts: {},
  domainCounts: {},
  metrics: {
    newThisWeek: 0,
    submitted: 0,
    active: 0,
    waitlist: 0,
    total: 0
  }
}; 